module.exports = __webpack_public_path__ + "media/images/courseware_resource center_clipboard-a6ceda6e3790a717b539587bdfff9978.png";